import { put, call, take, fork } from 'redux-saga/effects'
import { cardMediaDeleteService } from '../../api/card'
import { cardMediaDeleteSuccess } from '../../reducers/card/action'
import { CARD_MEDIA_DELETE } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* cardMediaDeleteFlow(payload) {
  try {
    const { id, questionId, callback } = payload
    yield call(cardMediaDeleteService, id)

    yield put(cardMediaDeleteSuccess(id, questionId))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardMediaDeleteWatcher() {
  while (true) {
    const action = yield take(CARD_MEDIA_DELETE)
    const { payload } = action

    yield fork(generalSaga, cardMediaDeleteFlow, payload)
  }
}
